import React from "react"
import Select, { createFilter } from "react-select"
import SelectErrorMessage from "./SelectErrorMessage"
import Label from "./Label"
import { selectFieldCustomStyle } from "../styles/customStyles"
import { formatId, formatAriaLabel } from "../utils/form"
import cx from "classnames"
import formStyles from "../styles/form.module.scss"

const SelectField = (props) => {
  const {
    fieldName,
    label,
    options,
    onChange,
    onBlur,
    value,
    hint,
    isMulti=false,
    closeMenuOnSelect=true,
    isDisabled=false,
    isLoading=false,
    placeholder="Select...",
    classNamePrefix="react-select",
    inputClass="",
    wrapperClass="",
    dataCy="",
    showErrorBorder=false,
    matchFrom="any",
    admin=false,
  } = props

  const handleChange = (selectedValue) => {
    onChange(fieldName, selectedValue)
  }

  const handleBlur = () => {
    onBlur(fieldName, true)
  }

  return (
    <div className={cx(formStyles.fieldRow, wrapperClass)} data-cy={dataCy}>
      <Label
        htmlFor={formatId(fieldName)}
        text={label}
        hint={hint}
        classNames={cx(formStyles.label, { [formStyles.admin]: admin })}
      />
      <Select
        styles={admin ? {} : selectFieldCustomStyle(showErrorBorder)}
        filterOption={createFilter({ matchFrom, ignoreCase: true })}
        className={inputClass}
        classNamePrefix={classNamePrefix}
        isMulti={isMulti}
        id={formatId(fieldName)}
        closeMenuOnSelect={closeMenuOnSelect}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        options={options}
        isDisabled={isDisabled}
        isLoading={isLoading}
        placeholder={placeholder}
        aria-label={formatAriaLabel(fieldName)}
        tabSelectsValue={false}
      />
      <SelectErrorMessage name={fieldName} />
    </div>
  )
}

export default SelectField
